/** A figure is right-aligned in mono only when it reads as a number, amount or date; words stay prose. */
const FIGURE = /^[\s₹Rs.,\d%()+\-–/:]*\d[\s₹Rs.,\d%()+\-–/:a-zA-Z]{0,14}$/

/** Two-column working table (label, value) with an optional note. The value column is figures
 * (mono, right) only when every value is one; otherwise the whole column reads as words. */
export function Table({ rows, note }: { rows: [string, string][]; note: string }) {
  const kind = rows.length && rows.every(([, b]) => FIGURE.test(b.trim())) ? "fig" : "txt"
  return (
    <div>
      <table className="tbl">
        <tbody>
          {rows.map(([a, b], i) => (
            <tr key={i}>
              <td>{a}</td>
              <td className={kind}>{b}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {note ? <p className="note">{note}</p> : null}
    </div>
  )
}
